import { useCartContext } from "app/providers/CartProvider";
import { useCheckoutInfoContext } from "pages/checkout/providers/CheckoutInfoProvider";
import { ShippingAddress } from "shared/api/middleware-api-client";
import { CustomerTypes } from "./usePersonalInfoReducer";
import {
  REACT_APP_DISABLE_CHECKOUT_PAYMENT_OPTIONS,
  STORAGE_IS_SAME_ADDRESS,
  STORAGE_PERSONAL_INFO_TYPE,
  STORAGE_SALE_LOCATION,
} from "shared/config";
import { useWarrantyData } from "./useWarrantyData";
import {
  paymentMethods,
  paymentMethodsCheckout,
} from "shared/utils/payment-methods";

export const useUpdateCartFromInfo = () => {
  const { state } = useCheckoutInfoContext();
  const cartContext = useCartContext();
  const cart = cartContext.getCart();
  const containsZakelijkProducts = cartContext.containsZakelijkProducts;
  const { warranties } = useWarrantyData();

  const updateCartFromInfo = () => {
    if (!cart) return;

    const updatedCart = { ...cart };

    let shippingAddress: ShippingAddress = {
      VAT: "",
      company: "",
      firstName: "",
      lastName: "",
      location: {
        type: "",
      },

      phone: "",
      reference: "",
      street: state.street,
      houseNumber: state.houseNumber,
      city: state.city,
      municipality: state.municipality,
      province: state.province,
      zip: state.zipCode.replace(/\s/g, ""),
      email: "",
    };
    if (state.type === CustomerTypes.PERSONAL) {
      shippingAddress.firstName = state.name;
      shippingAddress.lastName = state.surname;
      shippingAddress.phone = state.phoneNumber;

      shippingAddress.email = state.email;

      updatedCart.address.emailAddress = state.email;

      updatedCart.email = state.email;
      updatedCart.emailAddress = state.email;
    } else if (state.type === CustomerTypes.BUSINESS) {
      shippingAddress.company = state.companyName;
      shippingAddress.firstName = state.contactFirstName;
      shippingAddress.lastName = state.contactLastName;
      shippingAddress.reference = state.companyReference;
      shippingAddress.phone =
        state.shippingPhone !== ""
          ? state.shippingPhone
          : state.companyPhoneNumber;
      shippingAddress.VAT = state.vatNumber;
      shippingAddress.email = state.contactEmail;

      updatedCart.address.emailAddress = state.contactEmail;

      updatedCart.email = state.contactEmail;
      updatedCart.emailAddress = state.contactEmail;
    }
    updatedCart.address.shippingAddress = { ...shippingAddress };
    updatedCart.address.invoiceAddress = { ...shippingAddress };
    updatedCart.address.invoiceAddress.phone =
      state.type === CustomerTypes.BUSINESS
        ? state.companyPhoneNumber
        : state.phoneNumber;

    if (!state.isSameAddress) {
      updatedCart.address.invoiceAddress = {
        ...updatedCart.address.invoiceAddress,
        city: state.invoiceCity,
        houseNumber: state.invoiceHouseNumber,
        reference: state.invoiceReference,
        street: state.invoiceStreet,
        municipality: state.invoiceMunicipality,
        province: state.invoiceProvince,
        zip: state.invoiceZipCode.replace(/\s/g, ""),
      };
    }

    localStorage.setItem(
      STORAGE_IS_SAME_ADDRESS,
      JSON.stringify(state.isSameAddress),
    );
    localStorage.setItem(STORAGE_PERSONAL_INFO_TYPE, state.type);

    if (updatedCart.saleLocation === "") {
      updatedCart.saleLocation =
        localStorage.getItem(STORAGE_SALE_LOCATION) || "";
    }

    updatedCart.paymentMethod = {
      data: {
        issuer: "",
      },
      method: (REACT_APP_DISABLE_CHECKOUT_PAYMENT_OPTIONS
        ? paymentMethodsCheckout[0]
        : paymentMethods[0]
      ).action,
    };

    if (
      updatedCart?.warrantyPackage &&
      (updatedCart.warrantyPackage.packageId === "" ||
        updatedCart.warrantyPackage.packageId ===
          warranties.decideLaterWarrantyPackage.packageId ||
        updatedCart.warrantyPackage.packageId ===
          warranties.noWarrantyPayNowPackage.packageId)
    ) {
      updatedCart.warrantyPackage = undefined;
    }

    updatedCart.subscribeToNewsletter = state.receiveLetters;

    //Adjust bumbal flow based on zakelijk products
    if (containsZakelijkProducts) {
      updatedCart.bumbalFlow = "shipment";
    }
    cartContext.updateCart(updatedCart);
  };

  return { updateCartFromInfo };
};
